export default function Suggestion({
  testId,
  suggestion,
  suggestionIcons,
  inputValue,
  onChooseSuggestion,
}) {
  const startIndex = suggestion.label
    .toLowerCase()
    .indexOf(inputValue.toLowerCase())

  const hasMatch = startIndex !== -1

  const SuggestionIcon = suggestionIcons && suggestionIcons[suggestion.icon]

  return (
    <div
      id={testId} // Should be replace by a selectable element in Capybara
      data-testid={testId}
      onMouseDown={(e) => e.preventDefault()}
      onClick={(e) => {
        e.stopPropagation()
        onChooseSuggestion(suggestion)
      }}
      className="flex gap-x-1.5"
    >
      {suggestion.label === "-" && "-"}
      {suggestion.label !== "-" && (
        <>
          {SuggestionIcon && <SuggestionIcon className="h-5 w-5" />}
          {hasMatch && (
            <span title={suggestion.label}>
              {suggestion.label.substr(0, startIndex)}
              <strong>
                {startIndex === -1
                  ? ""
                  : suggestion.label.substr(startIndex, inputValue.length)}
              </strong>
              {suggestion.label.substr(startIndex + inputValue.length)}
            </span>
          )}
          {!hasMatch && <span>{suggestion.label}</span>}
        </>
      )}
    </div>
  )
}
